import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ClientContext } from "../../contexts/ClientContext";
import { DEFAULT_STATE } from "../../helper/defaultState";
import { v4 as uuidv4 } from "uuid";
import "../../styles/SetSelector.css";

const SetSelector = ({ app }) => {
  const { clientid } = useParams();
  const { items, updateClient, getClient, setCurrentSetId } = useContext(ClientContext);
  const [showForm, setShowForm] = useState(false);
  const [newSetName, setNewSetName] = useState("");
  const [currentItems, setCurrentItems] = useState([]);
  const ref = useRef();

  useEffect(() => {
    const onBodyClick = (event) => {
      if (ref.current.contains(event.target)) {
        return;
      }
      setShowForm(false);
    };
    document.body.addEventListener("click", onBodyClick, { capture: true });

    return () => {
      document.body.removeEventListener("click", onBodyClick, {
        capture: true,
      });
    };
  }, []);

  useEffect(() => {
    setCurrentItems(items);
  }, [items]);

  useEffect(() => {
    if (!currentItems || currentItems.length === 0) {
      getClient(clientid);
    }
  });

  const renderedThemeItems = () => {
    if (currentItems && currentItems.length !== 0) {
      return currentItems.map((item) => {
        return (
          <Link
            to={`/themeeditor/${clientid}/${app.toLowerCase()}/${item.setId}`}
            className="client-picker-item"
            key={item.setId}
            onClick={() => setCurrentSetId(item.setId)}>
            {item.setName}
          </Link>
        );
      });
    } else {
      return null;
    }
  };

  const handleNewSet = (e) => {
    e.preventDefault();
    if (!newSetName) {
      alert("Please Name the Set");
      return;
    }
    setShowForm(false);
    setNewSetName("");
    let newItems;
    if (!items) {
      newItems = [{ setName: newSetName, setId: uuidv4(), ColorRows: DEFAULT_STATE[app] }];
    } else {
      newItems = [
        ...items,
        { setName: newSetName, setId: uuidv4(), ColorRows: DEFAULT_STATE[app] },
      ];
    }
    updateClient({
      [app]: newItems,
    });
  };

  const renderedForm = (
    <form className="new-set-form" ref={ref}>
      <button className="header-link-item" type="button" onClick={(e) => handleNewSet(e)}>
        Create
      </button>
      <input
        type="text"
        name="setName"
        className="new-set-input"
        placeholder="New Set Name"
        value={newSetName}
        onChange={(e) => setNewSetName(e.target.value)}></input>

      <button className="header-link-item" type="button" onClick={() => setShowForm(false)}>
        Cancel
      </button>
    </form>
  );

  return (
    <>
      <div className="client-picker">
        <h2 className="client-picker-header">{`${app} Sets`}</h2>
        <div className="client-picker-grid">{renderedThemeItems()}</div>
        <div className="new-set">
          {showForm ? (
            renderedForm
          ) : (
            <button className="header-link-item" onClick={() => setShowForm(true)}>
              Add a New Set
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default SetSelector;
